import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import StaffProfileHoverCard from '@/components/StaffProfileHoverCard';
import useAPI from '@/hooks/useAPI';
import StaffProfileRepository from '@/repositories/StaffProfileRepository';
import { StaffProfile } from '@/types/staffProfile';
import formatStaffName from '@/utils/formatStaffName';

import { parseAbout } from '../StaffProfileCard/parseAbout';

import { Props } from './types';

export function hasProfileContent(profile: StaffProfile): boolean {
  return !!profile.photo_url || parseAbout(profile.about ?? '').length > 0;
}

const StaffNameWithProfile = ({ staff }: Props) => {
  const staffProfileRepository = StaffProfileRepository();

  const { data } = useAPI({
    queryKey: ['staffProfile', staff.id],
    queryFn: () => staffProfileRepository.getByStaffId(staff.id),
    supressErrorMessages: true
  });

  const profile = data?.data;
  // Always show the staff member's first + last name in this internal list; the
  // profile's preferred display_name still appears in the hover card header.
  const name = formatStaffName({ staff });

  if (profile && hasProfileContent(profile)) {
    return (
      <StaffProfileHoverCard profile={profile}>
        <span className="cursor-default whitespace-nowrap">
          <FontAwesomeIcon icon={faUser} className="mr-1 text-gray-400 text-xs" />
          {name}
        </span>
      </StaffProfileHoverCard>
    );
  }

  return <span>{name}</span>;
};

export default StaffNameWithProfile;
